"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coutries_1 = require("../../../config/coutries");
var isCountryInEu = function (countryCode) {
    if (coutries_1.euCountries.includes(countryCode))
        return true;
    else
        return false;
};
exports.default = isCountryInEu;
